import labels from "../../components/controls/shared/labels";
import { create } from "../spec-updater";
import {
    GenericCountdownIterator,
    GenericCountdownRegistration,
    type IGenericCountdownRegistration,
} from "./registrations/generic";
import { OldProductCountdownIterator } from "./registrations/old-product";
import {
    type IVueProductCountdownRegistration,
    VueProductCountdownRegistration,
    VueProductCountdownIterator,
} from "./registrations/vue-product";
import { type ICountdownItem } from "./types";

export function registerVueProductCountdown(
    options: IVueProductCountdownRegistration
): VueProductCountdownRegistration {
    const registration = new VueProductCountdownRegistration(options);
    VueProductCountdownIterator.registrations.push(registration);
    create().initialize();
    return registration;
}

export function registerGenericCountdown(
    options: IGenericCountdownRegistration
): GenericCountdownRegistration {
    const registration = new GenericCountdownRegistration(options);
    GenericCountdownIterator.registrations.push(registration);
    return registration;
}

function zeroFillByTen(v: any) {
    if (v < 10) return "0" + v;
    return v + "";
}

function loadTimer(callback: () => void) {
    const worker = new Worker(
        new URL("../timer-worker.worker.ts", import.meta.url)
    );
    worker.onmessage = (event: MessageEvent) => {
        if (event.data === "stop") {
            worker.terminate();
        } else {
            callback();
        }
    };

    worker.postMessage("start:" + 500);
    return {
        kill() {
            worker.terminate();
        },
    };
}

const scriptInitializedDate = new Date();

let controller: CountDownController | undefined;
export function globalSiteCounter() {
    if (controller == null) controller = new CountDownController();
    //console.log("CONTROLLER", controller);
    return controller;
}

export class CountDownController {
    iterators: OldProductCountdownIterator[];
    intervalTimer: { kill(): void } | undefined = undefined;
    constructor() {
        this.iterators = [
            new OldProductCountdownIterator(),
            new VueProductCountdownIterator(),
            new GenericCountdownIterator(),
        ];
    }

    public initialize() {
        this.intervalTimer = loadTimer(() => {
            this.tick();
        });
        return this;
    }

    private *iterateCountdowns(): Generator<ICountdownItem, any, any> {
        for (const iterator of this.iterators) {
            for (const item of iterator.getItems()) {
                yield item;
            }
        }
    }

    tick() {
        for (const countdown of this.iterateCountdowns()) {
            //if (countdown.shouldAppendToAuctionSocket) {
            //    auctionSocket.appendId(countdown.auctionSocketId);
            //}

            let initializedDate = countdown.getInitializedDate();
            if (initializedDate == null) {
                initializedDate = new Date();
                countdown.setInitializedDate(initializedDate);
            }

            let initialSeconds = countdown.getInitialSeconds();
            if (initialSeconds == null) {
                initialSeconds = countdown.getSecondsLeft();
                countdown.setInitialSeconds(initialSeconds);
            }

            let secondsLeft = countdown.getSecondsLeft();
            if (secondsLeft >= 0) {
                //Product refresh setup:

                // INIT COUNT-DOWN CLOCK
                if (secondsLeft >= 0) {
                    let hours = Math.floor(secondsLeft / 3600);
                    secondsLeft = secondsLeft % 3600;

                    const minutes = Math.floor(secondsLeft / 60);
                    const seconds = Math.floor(secondsLeft % 60);

                    const diff =
                        (initializedDate.getTime() - new Date().getTime()) /
                        1000;
                    countdown.setSecondsLeft(initialSeconds + diff);

                    if (countdown.textSetter != null) {
                        // format countdown string + set tag value
                        let dateTime = "";
                        if (hours > 24) {
                            const days = ~~(hours / 24);
                            hours = ~~(hours % 24);
                            dateTime +=
                                days +
                                " " +
                                labels.frontendProductList.countdownTimer
                                    ?.days +
                                " ";
                        }
                        dateTime +=
                            zeroFillByTen(hours) +
                            " : " +
                            zeroFillByTen(minutes) +
                            " : " +
                            zeroFillByTen(seconds);
                        countdown.textSetter(dateTime);
                    }
                }
            } else {
                if (countdown.textSetter != null) {
                    if (countdown.shouldShowTimeout()) {
                        countdown.textSetter("Started");
                    } else {
                        countdown.textSetter(
                            labels.frontendProductList.countdownTimer?.timeout
                        );
                    }
                }
            }
        }
    }
}
